module services {
    export module integration {
        export class SmartInvoiceService implements interfaces.integration.ISmartInvoiceService {
            static $inject = ["$resource", "ENV"];

            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig) {
            }

            getSmartInvoiceQueue(): ng.resource.IResourceClass<interfaces.integration.SmartInvoiceQueue> {
                return this.$resource<interfaces.integration.SmartInvoiceQueue>(this.ENV.DSP_URL + "SmartInvoice/GetSmartInvoiceQueue", {
                    connectSearch: '@connectSearch',
                    numberRecords: '@numberRecords',
                    pageNumber: '@pageNumber',
                }, {
                        query: {
                            method: 'GET',
                            isArray: true,
                            interceptor: { response: config.appResourceDateInterceptor.parseResponseDates },
                            params: {
                                numberRecords: 25,
                                pageNumber: 1,
                            }
                        }
                    });
            } 

          resetSmartInvoiceQueue(): ng.resource.IResourceClass<interfaces.applicationcore.IMessageHandler> {
                return this.$resource<interfaces.applicationcore.IMessageHandler>(this.ENV.DSP_URL + "SmartInvoice/ResetSmartInvoiceQueue", {
                    smartInvoiceQueueId : '@smartInvoiceQueueId'
                    });
            }

        }


    }
    angular.module("app").service("smartInvoiceService", services.integration.SmartInvoiceService);
}